<template>
  <v-main class="pa-2 range-report" fluid>
    <RangePicker @reloadData="loadData" :range="this.getDefaultWeek()" />

    <v-row v-if="checkGate('sales-access')">
      <v-col>
        <v-subheader>Sales</v-subheader>
        <v-data-table :headers="salesHeaders" :items="salesreport" :items-per-page="50" show-expand
          :expanded.sync="expanded" class="elevation-1">
          <template v-slot:expanded-item="{ salesHeaders, item }">
            <td :colspan="12" v-if="item.Notes != null || item.ccNotes != null || item.cashNotes != null">
              <ul class="notes">
                <li><sub>Notes</sub>
                  <p>{{ item.Notes }}</p>
                </li>
                <li><sub>Reason for CC Discrepancy</sub>
                  <p>{{ item.ccNotes }}</p>
                </li>
                <li><sub>Reason for Cash Discrepancy</sub>
                  <p>{{ item.cashNotes }}</p>
                </li>
              </ul>
            </td>
          </template>
          <template v-slot:item.T_Date="{ item }">
            {{ new Date(item.T_Date).toLocaleString("en-AU", {
              timeZone: "UTC", weekday: 'short', year: 'numeric', month:
                'short', day: 'numeric'
            }) }}
          </template>
          <template slot="body.append">
            <tr class="pink--text">
              <th class="text-start">&nbsp;</th>
              <th class="title">Totals</th>
              <th class="title">${{ sum(salesreport, 'totalSales') }}</th>
              <th class="title">${{ sum(salesreport, 'PP_Sales') }}</th>
              <th class="title">${{ sum(salesreport, 'calcCCSales') }}</th>
              <th class="title">${{ sum(salesreport, 'ccTerminal') }}</th>
              <th class="title">${{ sum(salesreport, 'ccDiscrepancy') }}</th>
              <th class="title">${{ sum(salesreport, 'calcCashSales') }}</th>
              <th class="title">${{ sum(salesreport, 'cashTotal') }}</th>
              <th class="title">${{ sum(salesreport, 'cashOnHand') }}</th>
              <th class="title">${{ sum(salesreport, 'cashDiscrepancy') }}</th>
              <th class="title">${{ sum(salesreport, 'deposited') }}</th>
              <th class="title">${{ sum(salesreport, 'banked') }}</th>
            </tr>
          </template>

        </v-data-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" v-if="user.roles.includes('instructor') || user.roles.includes('admin')">
        <v-subheader>Jumps</v-subheader>
        <v-select :disabled="this.user.roles.includes('instructor')" v-model="currentInstructor" :items="instructors"
          item-text="name" item-value="id" label="Select Instructor">
        </v-select>


        <v-data-table no-data-text="Select an Instructor from the list above" :headers="headers" :items="detailbyID"
          item-key="id">
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ new Date(item.startTime).toLocaleString("en-AU", {
                  timeZone: "UTC", weekday: 'short', year: 'numeric',
                  month: 'short', day: 'numeric'
                }) }}
              </td>
              <td>{{ item.name }}</td>
              <td>{{ item.jumps }}</td>
              <td>{{ item.wc }}</td>
              <td>{{ item.wc2 }}</td>

            </tr>
          </template>
          <template slot="body.append">
            <tr class="pink--text">
              <th class="title">Totals</th>
              <th class="title">&nbsp;</th>
              <th class="title">{{ sum(detailbyID, 'jumps') }}</th>
              <th class="title">{{ sum(detailbyID, 'wc') }}</th>
              <th class="title">{{ sum(detailbyID, 'wc2') }}</th>

            </tr>
          </template>
        </v-data-table>
      </v-col>


      <v-col cols="12" md="6" v-if="checkGate('aircrafts-log-mgmt')">
        <v-subheader>Loads</v-subheader>
        <v-select v-model="currentPilot" :disabled="this.user.roles.includes('pilot')" :items="pilots" item-text="name"
          item-value="id" label="Select Pilot">
        </v-select>


        <v-data-table :headers="loadsHeaders" no-data-text="Select a Pilot from the list above" :items="loadsByPilot"
          item-key="id">
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ new Date(item.loadDate).toLocaleString("en-AU", {
                  timeZone: "UTC", weekday: 'short', year: 'numeric',
                  month: 'short', day: 'numeric'
                }) }}
              </td>
              <td>{{ item.name }}</td>
              <td>{{ item.completed }}</td>
            </tr>
          </template>
          <template slot="body.append">
            <tr class="pink--text">
              <th class="title">Totals</th>
              <th class="title">&nbsp;</th>
              <th class="title">{{ sum(loadsByPilot, 'completed') }}</th>

            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>





    <v-row v-if="checkGate('aircrafts-log-mgmt')">
      <v-col cols="12">
        <v-subheader class="space">Aicrafts Log</v-subheader>
      </v-col>
      <v-col cols="12" md="6">
        <v-select v-model="currentPlain" :items="plains" item-text="name" item-value="id" label="Select Aircraft">
        </v-select>

      </v-col>
      <v-col cols="12" md="6">

        <v-select v-model="currentPilot" :disabled="this.user.roles.includes('pilot')" :items="pilots" item-text="name"
          item-value="id" label="Select Pilot">
        </v-select>

      </v-col>
    </v-row>


    <v-data-table :headers="logHeaders" :items="logsByPlain" :items-per-page="50" flat
      v-if="checkGate('aircrafts-log-mgmt')">
      <template v-slot:item.loadDate="{ item }">
        {{ new Date(item.loadDate).toLocaleString("en-AU", {
          timeZone: "UTC", weekday: 'short', year: 'numeric', month:
            'short', day: 'numeric'
        }) }}
      </template>
      <template v-slot:item.oil="{ item }">
        <span v-if="item.oil">{{ item.oil }} qts</span></template>
      <template v-slot:item.fuel="{ item }">
        <span v-if="item.fuel">{{ item.fuel }} gal</span></template>
        <template v-slot:item.timeXLoad="{ item }">
          <span v-if="item.timeXLoad">{{ item.timeXLoad.toFixed(2) }} </span></template>
      
      <template v-slot:item.tach_hrs="{ item }">{{ item.tach_hrs.toFixed(2) }}</template>
      <template slot="body.append">
        <tr class="pink--text">
          <th class="title">Totals</th>
          <th class="title">{{ sum(logsByPlain, 'hobbs') }}</th>
          <th class="title">{{ sum(logsByPlain, 'tachtime') }}</th>
          <th class="title">{{ sum(logsByPlain, 'oil') }} qts</th>
          <th class="title">{{ sum(logsByPlain, 'fuel') }} gal</th>
          <th class="title"> &nbsp;</th>
          <th class="title"> &nbsp;</th>
          <th class="title">{{ sum(logsByPlain, 'completeLoads') }}</th>
          <th class="title">{{ sum(logsByPlain, 'tach_hrs') }}</th>
          <th class="title">{{ (sum(logsByPlain, 'tach_hrs') / sum(logsByPlain, 'completeLoads')).toFixed(2) || 0 }}</th>
          <th class="title">{{ avg(logsByPlain, 'fuelXLoad') || 0 }}</th>
        </tr>
      </template>
    </v-data-table>

    <v-row v-if="checkGate('packing-jobs-mgmt')">

      <v-col cols="12" md="6">

        <v-subheader>Packing Jobs by Date</v-subheader>

        <v-data-table :headers="packingJobsHeaders" no-data-text="Change the Date Period to see information"
          :items="packingjobs">
          <template v-slot:item.packDate="{ item }">
            {{ new Date(item.packDate).toLocaleString("en-AU", {
              timeZone: "UTC", weekday: 'short', year: 'numeric',
              month: 'short', day: 'numeric'
            }) }}

          </template>
          <template slot="body.append">
            <tr class="pink--text">
              <th v-for="(item, index) in packingJobsHeaders" class="title">
                {{ index > 0 && index <= 3 ? sum(packingjobs, item.value) : " " }} </th>

            </tr>
          </template>
        </v-data-table>
      </v-col>


      <v-col cols="12" md="6">

        <v-select max-width="30%" v-model="currentPacker" :items="packers" item-text="name" item-value="id"
          label="Select Packer">
        </v-select>

        <v-data-table :headers="packingJobsbyRigHeaders" no-data-text="Select a Packer from the list above"
          :items="jobsByPacker">



          <template v-slot:item.total="{ item }">
            <span class="pink--text title">{{ item.total }}</span>
          </template>

          <template v-slot:item.packDate="{ item }">
            {{ new Date(item.packDate).toLocaleString("en-AU", {
              timeZone: "UTC", weekday: 'short', year: 'numeric',
              month: 'short', day: 'numeric'
            }) }}

          </template>
          <template slot="body.append">
            <tr class="pink--text">
              <th v-for="(item, index) in packingJobsbyRigHeaders" class="title">
                {{ index > 1 ? sum(jobsByPacker, item.value) : " " }}
              </th>

            </tr>
          </template>
        </v-data-table>

      </v-col>


    </v-row>

  </v-main>
</template>


<script>
import { mapState } from 'vuex'
import RangePicker from '../components/RangePicker.vue'



export default {
  components: { RangePicker },

  data() {

    return {
      logHeaders: [
        { text: "Date", align: 'left', value: "loadDate", sortable: false },

        { text: "Hobbs", align: 'left', value: "hobbs", sortable: false },
        { text: "Tachtime", align: 'left', value: "tachtime", sortable: false },
        { text: "Oil", align: 'left', value: "oil", sortable: false },
        { text: "Fuel", align: 'left', value: "fuel", sortable: false },
        { text: "Squawks", align: 'left', value: "squawks", sortable: false },
        { text: "Pilot", align: 'left', value: "pilot", sortable: false },
        { text: "Complete Loads", align: 'left', value: "completeLoads", sortable: false },
        { text: "Tach Hrs", align: 'left', value: "tach_hrs", sortable: false },
        { text: "Time per Load", align: 'left', value: "timeXLoad", sortable: false },
        { text: "Fuel per Load", align: 'left', value: "fuelXLoad", sortable: false },
      ],

      salesHeaders: [
        // { text: '', align: 'start', value: 'ExpandAll' }
        { text: "Date", align: 'left', value: "T_Date", sortable: true },
        { text: "Total Calc", align: 'left', value: "totalSales", sortable: true },
        { text: "Prepaid", align: 'left', value: "PP_Sales", sortable: true },

        { text: "CC", align: 'left', value: "calcCCSales", sortable: true },
        { text: "Terminal", align: 'left', value: "ccTerminal", sortable: true },
        { text: "CC Disc", align: 'left', value: "ccDiscrepancy", sortable: true },


        { text: "Cash", align: 'left', value: "calcCashSales", sortable: true },
        { text: "Total", align: 'left', value: "cashTotal", sortable: true },
        // { text : "Start", align: 'left', value: "cashStart", sortable : false },
        { text: "On Hand", align: 'left', value: "cashOnHand", sortable: true },
        { text: "Cash Disc", align: 'left', value: "cashDiscrepancy", sortable: true },
        { text: "Deposited", align: 'left', value: "deposited", sortable: true },
        { text: "Banked", align: 'left', value: "banked", sortable: true },

      ],

      headers: [
        { text: "Date", align: 'left', value: "startTime" },
        { text: "Name", align: 'left', value: "name" },
        { text: "Jumps", align: 'left', value: "jumps" },
        { text: "WC", align: 'left', value: "wc" },
        { text: "lb/wc1", align: 'left', value: "wc2" },
      ],


      loadsHeaders: [
        { text: "Date", align: 'left', value: "loadDate" },
        { text: "Name", align: 'left', value: "name" },
        { text: "Loads", align: 'left', value: "total" }
      ],

      dialog: false,
      currentInstructor: null,
      currentPlain: null,
      currentPacker: 1,
      currentPilot: null,

    }
  },


  mounted() {

    if (this.checkGate('sales-access')) {
      this.$store.dispatch('fetchSalesReportbyRange', {
        range: this.getDefaultWeek()
      })
    }



    if (this.instructors.length == 0 && (this.user.roles.includes('instructor') || this.user.roles.includes('admin')))

      this.$store.dispatch('fetchInstructors').then(() => {

        if (this.user.roles.includes('instructor')) {

          this.currentInstructor = this.instructors.find(i =>
            i.user_id == this.user.id
          ).id

        }

      })

    if (this.plains.length == 0 && this.checkGate('aircrafts-log-mgmt'))
      this.$store.dispatch('fetchPlains')

    if (this.packers.length == 0)
      this.$store.dispatch('fetchPackers')

    if (this.pilots.length == 0 && this.checkGate('aircrafts-log-mgmt'))
      this.$store.dispatch('fetchPilots').then(() => {

        if (this.user.roles.includes('pilot')) {

          this.currentPilot = this.pilots.find(p =>
            p.user_id == this.user.id
          ).id

        }

      })

    if (this.user.roles.includes('instructor') || this.user.roles.includes('admin')) {
      this.$store.dispatch('fetchJumpsbyInstructor', {
        range: this.getDefaultWeek()

      })
    }

    if (this.user.roles.includes('pilot') || this.user.roles.includes('admin')) {
      this.$store.dispatch('fetchLoadsbyPilot', {
        range: this.getDefaultWeek()

      })
    }

    if (this.checkGate('aircrafts-log-mgmt')) {
      this.$store.dispatch('fetchLogsbyPlain', {
        range: this.getDefaultWeek()
      })
    }

    this.$store.dispatch('fetchPackingJobsReport', {
      range: this.getDefaultWeek()
    })


    this.$store.dispatch('fetchDetailJobsbyPacker', {
      range: this.getDefaultWeek()

    })

  },


  computed: {
    ...mapState([
      'salesreport',
      'logsbyplainrange',
      'plains',
      'pilots',
      'detail',
      'pilots_detail',
      'instructors',
      'detailbypacker',
      'packingjobs',
      'packers',
      'user'

    ]),

    packingJobsHeaders() {
      return this.getHeaders(this.packingjobs)

    },

    packingJobsbyRigHeaders() {
      return this.getHeaders(this.detailbypacker)
    },


    detailbyID() {

      var jumpsByInstructor = this.currentInstructor ? this.detail.filter(detail => detail.id == this.currentInstructor) : this.detail
      return jumpsByInstructor
    },


    loadsByPilot() {

      var loadsbypilot = this.currentPilot ? this.pilots_detail.filter(detail => detail.id == this.currentPilot) : this.pilots_detail
      return loadsbypilot
    },

    jobsByPacker() {

      return this.detailbypacker.filter(detail => detail.id == this.currentPacker)

    },


    expanded: {

      get() {
        return this.salesreport
      },

      set(items) {
        return items
      }
    },


    logsByPlain() {



      var logsbyplainrange = this.currentPlain ? this.logsbyplainrange.filter(detail => detail.plain_id == this.currentPlain) : this.logsbyplainrange


      logsbyplainrange = this.currentPilot ? logsbyplainrange.filter(detail => detail.pilot_id == this.currentPilot) : logsbyplainrange


      return logsbyplainrange

    }


  },


  methods: {


    loadData(range) {

      if (this.checkGate('sales-access')) {
        this.$store.dispatch('fetchSalesReportbyRange', {
          range: range

        })
      }


      if (this.checkGate('aircrafts-log-mgmt')) {
        this.$store.dispatch('fetchLogsbyPlain', {
          range: range
        })
      }

      this.$store.dispatch('fetchPackingJobsReport', {
        range: range
      })

      if (this.user.roles.includes('instructor') || this.user.roles.includes('admin')) {
        this.$store.dispatch('fetchJumpsbyInstructor', {
          range: range
        })
      }

      if (this.user.roles.includes('pilot') || this.user.roles.includes('admin')) {
        this.$store.dispatch('fetchLoadsbyPilot', {
          range: range
        })
      }

      this.$store.dispatch('fetchDetailJobsbyPacker', {
        range: range
      })


    },


  }
}
</script>
